export default function Play(props: any) {
    return (
        <svg
            width="18px"
            height="18px"
            viewBox="0 0 18 18"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            {...props}
        >
            <g id="MH100详情" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MH100详情-版本2" transform="translate(-1023.000000, -366.000000)" fillRule="nonzero">
                    <g id="编组-7" transform="translate(861.000000, 353.000000)">
                        <g id="01-1视频播放button" transform="translate(162.000000, 13.000000)">
                            <path
                                d="M9,0 C13.9705629,0 18,4.02943725 18,9 C18,13.9705628 13.9705629,18 9,18 C4.02943714,18 0,13.9705628 0,9 C0,4.02943725 4.02943714,0 9,0 Z"
                                id="路径"
                                fill={props?.fillBg || '#000000'}
                            ></path>
                            <path
                                d="M7.0917843,4.8 C6.82017872,4.8 6.6,5.0349585 6.6,5.32479456 L6.6,5.32479456 L6.6,12.675131 C6.6,12.7719675 6.62510756,12.8669159 6.67254507,12.9494676 C6.81452713,13.1965487 7.11732561,13.2740227 7.34886455,13.1225108 L7.34886455,13.1225108 L12.9652262,9.44734257 C13.0313024,9.40410422 13.0868661,9.34481125 13.1273852,9.27429943 C13.2693663,9.02721839 13.1967661,8.70409493 12.9652262,8.55258296 L12.9652262,8.55258296 L7.34886455,4.87741475 C7.27150589,4.82679339 7.18252933,4.8 7.0917843,4.8 Z"
                                id="路径"
                                fill={props?.fillTrangle || '#FFFFFF'}
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
